module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/audience.105efd6ff4bb2e08ed174a29a24e94d2.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/audience.png
// module id = 1712
// module chunks = 1